import React from "react";
import { Link } from "react-router-dom";
import logoMgsul from "../../imagens/logos/logoMgSUL.png";
import { useTranslation } from "react-i18next";

const HomeAbout = () => {
  const { t } = useTranslation();

  return (
    <section className="container py-5 d-flex justify-content-center">
      <div className="row align-items-center justify-content-around gy-4">

        {/* TEXTO 
           - col-12: Ocupa toda a linha no Mobile (força a imagem para baixo)
           - col-md-6: Ocupa metade no Desktop (lado a lado)
        */}
        <div className="col-12 col-md-6 col-sm-6 text-center text-md-start">
          <h2 className="fw-bold mb-3 TextAboutUsContainer">
            {t("homeAbout.title")}
          </h2>
          <p className="mb-4 TextAboutUsContainer">
            {t("homeAbout.description")}
          </p>
          {/* Container do botão ajustado para alinhar com o texto */}
          <div className="d-flex justify-content-center justify-content-md-start">
            <Link to="/AboutUs" className="btn btn-success fw-bold px-4 py-2">
              {t("homeAbout.button")}
            </Link>
          </div>
        </div>

        {/* IMAGEM
           - col-12: Ocupa toda a linha no Mobile
           - d-flex justify-content-center: Garante que a imagem fique no meio da linha
        */}
        <div className="col-md-3 col-sm-4 d-flex justify-content-center mt-3 mt-md-0">
            <img
              src={logoMgsul}
              alt={t("homeAbout.imageAlt")}
              // d-block e mx-auto são redundantes se o pai tem justify-content-center, 
              // mas mantive para garantir segurança extra
              className="img-fluid rounded custom-img d-block mx-auto"
            />
        </div>

      </div>  
    </section>
  );
};

export default HomeAbout;